import React from "react";
import NoSSR from "react-no-ssr";
import Wrapper from "../../components/Keywords/Wrapper";

const KeywordsPage = () => (
  <NoSSR>
    <Wrapper
      routes={[
        { name: "Keyword's", pathname: "/keywords" },
        { name: "Ranking", pathname: "/keywords" },
      ]}
    />
  </NoSSR>
);

export default KeywordsPage;
